import { Grid } from '@mui/material';
import ConfigurationField from './ConfigurationField';
import SectionHeader from './SectionHeader';
import {
  SECTION_BOTTOM_MARGIN,
  SECTION_GRID_SPACING,
} from '../paymentsManagerConfiguration.constants';

const FilePrefixesSection = ({ form, fieldErrors, onChange, disabled }) => (
  <>
    <SectionHeader>File prefixes</SectionHeader>
    <Grid
      container
      spacing={SECTION_GRID_SPACING}
      sx={{ mb: SECTION_BOTTOM_MARGIN }}>
      <Grid item xs={12} md={6} lg={3}>
        <ConfigurationField
          name='payments_manager_prefix'
          label='Payments Manager prefix'
          value={form.payments_manager_prefix}
          onChange={onChange}
          error={fieldErrors.payments_manager_prefix}
          disabled={disabled}
          tooltip='Prefix used to identify outbound Payments Manager files'
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <ConfigurationField
          name='ack_prefix'
          label='ACK prefix'
          value={form.ack_prefix}
          onChange={onChange}
          error={fieldErrors.ack_prefix}
          disabled={disabled}
          tooltip='Prefix used to identify acknowledgement files'
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <ConfigurationField
          name='notification_prefix'
          label='Zelle notification prefix'
          value={form.notification_prefix}
          onChange={onChange}
          error={fieldErrors.notification_prefix}
          disabled={disabled}
          tooltip='Prefix used to identify Zelle notification files'
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <ConfigurationField
          name='recon_prefix'
          label='Recon prefix'
          value={form.recon_prefix}
          onChange={onChange}
          error={fieldErrors.recon_prefix}
          disabled={disabled}
          tooltip='Prefix used to identify reconciliation files'
        />
      </Grid>
    </Grid>
  </>
);

export default FilePrefixesSection;
